module.exports = __webpack_public_path__ + "static/img/topxiang.f87295f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topxiang.jpg
// module id = 0b7m
// module chunks = 2